import {NameWithId} from "@utils/Models";

export function formatColourTypeLabel(item: Pick<NameWithId, "Name" | "Prefix"> | null | undefined): string {
    if (!item) return "";
    return item.Prefix ? `[${item.Prefix}] ${item.Name}` : item.Name;
}
